module.exports = __webpack_public_path__ + "static/media/pdf.07cfcb33.png";